module.exports = __webpack_public_path__ + "static/media/nav-icon-managing-performers-active.e035829c.svg";